import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import { useItemTooltip } from "@mui/x-charts/ChartsTooltip";

import { ChartLegendItem } from "./ChartLegendItem";
import { ChartDataPoint } from "./types";

interface DonutChartTooltipProps {
  dataPoints?: ChartDataPoint[];
}

export const DonutChartTooltip = ({ dataPoints }: DonutChartTooltipProps) => {
  const theme = useTheme();
  const tooltipData = useItemTooltip<"pie">();

  if (!tooltipData) {
    return null;
  }

  const matchedDataPoint = dataPoints?.[tooltipData.identifier.dataIndex];
  const displayValue = matchedDataPoint?.formattedValue ?? tooltipData.value.value;

  return (
    <Paper
      key={tooltipData.identifier.dataIndex}
      elevation={2}
      sx={{
        padding: theme.spacing(1, 2),
      }}
    >
      <ChartLegendItem label={tooltipData.label} value={displayValue} color={tooltipData.color} wrap />
    </Paper>
  );
};
